import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const usePricingProcess = () => {
  const { user } = useAuth();
  
  const dynamicHook = useDynamicEntity({
    entityType: 'pricingProcess',
    gqlEntityKey: 'pricing_process',
    queryName: 'GET_PRICING_PROCESSES_QUERY',
    createMutation: 'CREATE_PRICING_PROCESS_MUTATION',
    updateMutation: 'UPDATE_PRICING_PROCESS_MUTATION',
    deleteMutation: 'DELETE_PRICING_PROCESS_MUTATION',
    updateVariableName: '_set',
    transformData: (process) => ({
      ...process,
      processName: process.name,
      companyId: process.company_id,
      companyName: process.company?.name || `Company ${process.company_id}`,
      status: process.status ? 'active' : 'inactive',
    }),
    transformFormData: (formData) => {
      return {
        name: formData.processName,
        description: formData.description,
        company_id: formData.companyId || user?.companyId,
        status: formData.status === 'active',
      };
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
    mutationPattern: 'pricingProcess',
    createVariableName: 'template',
    updateVariableName: '_set',
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { usePricingProcess };
